import { Currency, DEV, Token } from "../jibswap"

export function currencyId(currency: Currency): string {
  if (currency === DEV) return "JBC"
  if (currency instanceof Token) return currency.address
  throw new Error("invalid currency")
}
